import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";

import { createClassNameString } from "@/utils/createClassNameString";
import { isUserPatient } from "@/utils/authToken";

import { getPatientProfile } from "../../../redux/actions/auth";
import Spinner from "../../UI/Spinner";

import { ChannelsSideBar } from "./Channel/ChannelsSideBar";
import { Chat } from "./Chat/Chat";

const FIVE_MINUTES_IN_MS = 300000;

export const MessagesContainer = (props) => {
  const {
    channels,
    client,
    fetchMessagingInfo,
    isInactive,
    isMobile,
    loadingMoreChannels,
    mobileView,
    nextChannelPageQuery,
    onMessageReceived,
    onSelectChannel,
    selectedChannel,
    showMoreChannels,
    switchMessagesOrAddChannelView,
    switchMobileView,
    user,
  } = props;

  const dispatch = useDispatch();

  useEffect(() => {
    // Check for care team member updates to set chats to readonly
    if (isUserPatient()) {
      const interval = setInterval(() => {
        dispatch(getPatientProfile(false));
      }, FIVE_MINUTES_IN_MS);

      return () => {
        clearInterval(interval);
      };
    }
  }, []);

  const browserChannelSideBarClassNames = "col-12 col-sm-5 col-md-5 col-lg-4 col-xl-3";
  const channelSideBarClassName = createClassNameString([
    "Messages__ChannelSideBar",
    "container",
    isMobile ? "" : browserChannelSideBarClassNames,
  ]);
  const chatClassName = createClassNameString(["Messages__Chat", isMobile ? "" : "col"]);

  const showChannelSideBar = !isMobile || mobileView === "CHANNEL_SELECT";
  const showChat = !isMobile || mobileView === "CHAT";

  return (
    <div className="Messages row no-gutters">
      {showChannelSideBar && (
        <div className={channelSideBarClassName}>
          <ChannelsSideBar
            channels={[...channels]}
            client={client}
            hasMoreChannels={!!nextChannelPageQuery}
            onMessageReceived={onMessageReceived}
            onSelectChannel={onSelectChannel}
            showMoreChannels={showMoreChannels}
            switchView={switchMessagesOrAddChannelView}
          />
        </div>
      )}
      {loadingMoreChannels && <Spinner />}

      {showChat && (
        <div className={chatClassName}>
          <Chat
            channel={selectedChannel}
            client={client}
            isInactive={isInactive}
            isMobile={isMobile}
            refetch={fetchMessagingInfo}
            switchMobileView={switchMobileView}
            user={user}
          />
        </div>
      )}
    </div>
  );
};

MessagesContainer.propTypes = {
  channels: PropTypes.array.isRequired,
  client: PropTypes.object.isRequired,
  fetchMessagingInfo: PropTypes.func.isRequired,
  isInactive: PropTypes.bool.isRequired,
  isMobile: PropTypes.bool.isRequired,
  loadingMoreChannels: PropTypes.bool.isRequired,
  mobileView: PropTypes.string.isRequired,
  nextChannelPageQuery: PropTypes.string,
  onSelectChannel: PropTypes.func.isRequired,
  selectedChannel: PropTypes.object.isRequired,
  showMoreChannels: PropTypes.func.isRequired,
  switchMessagesOrAddChannelView: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
};
